import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Send } from "lucide-react";
import { TELEGRAM_URL } from "@/config";

export default function StickyCta() {
    const [visible, setVisible] = useState(false);
    useEffect(() => {
        const onScroll = () => setVisible(window.scrollY > 560);
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <AnimatePresence>
            {visible && (
                <>
                    <motion.div
                        key="sticky-bar"
                        initial={{ y: 96 }}
                        animate={{ y: 0 }}
                        exit={{ y: 96 }}
                        transition={{ type: "spring", stiffness: 260, damping: 26 }}
                        className="fixed inset-x-0 bottom-0 z-50 flex items-center justify-between gap-3 border-t border-white/10 bg-ink/95 px-4 pb-[calc(0.75rem+env(safe-area-inset-bottom))] pt-3 backdrop-blur-lg md:hidden"
                        data-testid="sticky-cta-mobile"
                    >
                        <p className="text-xs font-semibold leading-tight text-white/85">
                            Offerte ogni giorno,
                            <br />
                            <span className="text-telegram-glow">gratis direttamente su Telegram</span>
                        </p>
                        <a
                            href={TELEGRAM_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="sticky-telegram-cta"
                            className="inline-flex shrink-0 items-center gap-2 rounded-full bg-telegram px-4 py-2.5 text-[13px] font-bold text-white"
                        >
                            <Send className="h-4 w-4" />
                            Entra ora
                        </a>
                    </motion.div>

                    <motion.a
                        key="sticky-pill"
                        href={TELEGRAM_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="sticky-telegram-cta-desktop"
                        initial={{ opacity: 0, scale: 0.8, y: 16 }}
                        animate={{ opacity: 1, scale: 1, y: 0 }}
                        exit={{ opacity: 0, scale: 0.8, y: 16 }}
                        transition={{ type: "spring", stiffness: 260, damping: 22 }}
                        className="btn-shine fixed bottom-6 right-6 z-50 hidden items-center gap-2.5 rounded-full bg-telegram px-6 py-4 font-display text-sm font-semibold uppercase tracking-wide text-white shadow-[0_18px_45px_-10px_rgba(14,122,184,0.6)] transition-colors duration-300 hover:bg-telegram-deep md:inline-flex"
                    >
                        <Send className="h-4 w-4" />
                        Entra nel canale Telegram
                    </motion.a>
                </>
            )}
        </AnimatePresence>
    );
}
